import React, { useEffect, useState } from 'react'
import BorderBtn from './BorderBtn';
import Link from 'next/link';
import * as Yup from 'yup';
import { Field } from 'formik';

  export default function NewsLetterBox ({data=null, customFields, page_name, product_name, form_name, formTitle, endpoint=null, extraValues=null, slug=null}) {

    return (
      <>
        <section className="bg-[#012A5E]">
          <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col md:flex-row mx-auto md:justify-between md:items-center lg:flex-row py-3">
            <h3 className="text-white text-lg font-semibold leading-6 text-center md:text-left md:pb-0 pb-5">
              {data?.title}
            </h3>
            <div className="md:mx-0 mx-auto rounded flex justify-end items-center space-x-2 px-4 py-2 text-white">
              <BorderBtn 
                buttonLink={(data?.link)?data?.link:false}
                buttonTitle={data.buttonTitle}
                customClass="text-white bg-[#1b5df3] border-0 rounded-none p-2"
                customFields={customFields}
                extraValues={extraValues}
                page_name={page_name}
                product_name={product_name}
                form_name={form_name}
                formTitle={formTitle}
                endpoint={endpoint}
                onclick={(data.click)?(data.click):false}
              />
            </div>
          </div>
        </section>
      </>
    )
  };
